import { Controller } from 'stimulus';
import TingleModal from 'tingle.js';


export default class extends Controller {
  static targets = ['template'];

  open(event) {
    console.log("CLICKED");
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.hasTemplateTarget) return;

 
    const modal = new TingleModal.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: 'Close',
      cssClass: ['app-download-modal-tingle'],
      onOpen: () => {},
      onClose: () => {
        modal.destroy();
      }
    });

    modal.setContent(this.templateTarget.innerHTML);
    modal.open();
  }
}


